export const headingConstants = [{ text: 'New at JB!', highlightedText: 'New' }];
